import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import AppProvider from 'providers/AppProvider';
import { ProjectProvider } from 'contexts/ProjectContext';
import { router } from 'routes';
import 'helpers/initFA';

const container = document.getElementById('main');
const root = createRoot(container);

// MenuBadgeProvider теперь живёт внутри MainLayout (после PrivateRoute),
// не на уровне root — иначе polling AML/KYC count'ов работает на /login
// и после logout, что приводит к 401-loop.
root.render(
  <React.StrictMode>
    <AppProvider>
      <ProjectProvider>
        <RouterProvider router={router} />
      </ProjectProvider>
    </AppProvider>
  </React.StrictMode>
);
